import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from './helpers';

export type StatusProps = ComponentProps<'span'> &
  VariantProps<typeof statusVariants> & {
    asChild?: boolean;
    isLoading?: boolean;
    loaderFallback?: React.ReactNode;
  };

const statusVariants = cva('rounded-full text-xs px-3 py-2', {
  variants: {
    variant: {
      active: 'bg-blue-100 text-blue-500',
      inActive: 'bg-[#6C757D]/10 text-[#6C757D]',
      success: 'bg-green-100 text-green-500',
      pending: 'bg-yellow-100 text-yellow-500',
      danger: 'bg-red-100 text-destructive',
    },
  },
  defaultVariants: {
    variant: 'active',
    // size: 'lg',
  },
});

export const Status = ({ className, variant, ...props }: StatusProps) => {
  return (
    <span
      className={cn(statusVariants({ variant }), className)}
      {...props}
    />
  );
};
